import React from 'react';
import { pipe } from 'ramda';
import PropTypes from 'prop-types';

import { inlineEditorHtml, stripHtmlString } from '../../common/helpers/browser';

const isEmptyHtml = htmlString => !htmlString || htmlString === '<p><br/></p>';
const formatHtml = pipe(inlineEditorHtml, stripHtmlString);

const Subject = ({ value, onClick, defaultText }) => {
  const inlinedValue = value ? formatHtml(value) : value;

  if (isEmptyHtml(inlinedValue)) {
    return (
      <div className="c-editable-text c-editable-text--inline u-co-red" onClick={onClick}>
        {defaultText}
      </div>
    );
  }

  return (
    <div
      className="c-editable-text c-editable-text--inline u-text-trim"
      dangerouslySetInnerHTML={{ __html: inlinedValue }}
      onClick={onClick}
    />
  );
};

Subject.propTypes = {
  defaultText: PropTypes.string,
  value: PropTypes.string,
  onClick: PropTypes.func,
};

Subject.defaultProps = {
  defaultText: '',
  value: '',
  onClick: () => {},
};

export default Subject;
